<template>
  <div class="row">
    <div class="col-lg-4 col-xs-12">
      <b-card>
        <h6 class="card-title mt-0 mb-2">{{$t('views.exsbbankpackages.index.sendPackage')}}</h6>
        <b-card-body>
          <vue-form :state="formstate" @submit.prevent="onSubmit" class="row">
            <div class="form-group col-sm-12 col-lg-12">
              <label>{{$t('views.exsbbankpackages.form.idBank')}}:</label>
              <b-form-select v-model="data.idBank" name="idBank" :options="banksOptions" required class="">
              </b-form-select>
              <field-messages name="idBank" show="$invalid && $submitted" class="text-danger">
                <div slot="idBank">{{$t("views.exsbbankpackages.form.idBankRequired")}}</div>
              </field-messages>
            </div>
            <div class="form-group col-sm-12 col-lg-12">
              <label>{{$t('global.description')}}:</label>
              <input v-model="data.description" name="description" type="text" autofocus :placeholder="$t('global.description')" class="form-control"/>
              <field-messages name="description" show="$invalid && $submitted" class="text-danger">
                <div slot="description">{{$t("views.exsbbankpackages.form.descriptionRequired")}}</div>
              </field-messages>
            </div>
            <div class="form-group col-sm-12 col-lg-12">
              <label>{{$t('views.exsbbankpackages.form.selectFile')}}:</label>
              <!-- <input id="file" type="file" class="form-control"/> -->
              <b-form-file name="bankFile" accept=".html, .txt, .csv, .xls, .xlt, .xml, .xlsx" v-model="data.bankFile" :state="Boolean(data.bankFile)" :placeholder="$t('views.exsbbankpackages.form.selectFile')"></b-form-file>
              <div v-if="data.bankFile" class="mt-3">{{$t('views.exsbbankpackages.form.selectFile')}}: {{data.bankFile && data.bankFile.name}}</div>
            </div>
            <div class="form-group col-sm-12 col-lg-12 pb-2">
              <div class="float-left" v-if="display">
                <input type="submit" :value="$t('buttons.submit')" class="btn btn-success" />
                <a class="btn btn-info" @click="cancelButton()">{{ $t("buttons.cancel") }}</a>
              </div>
              <Loader v-else></Loader>
            </div>
          </vue-form>
          <div class="pl-4 ml-2" v-if="(loadingResults.addedPayments && loadingResults.addedPayments.length > 0) ||
                (loadingResults.paymentNotAdd && loadingResults.paymentNotAdd.length > 0) || (loadingResults.totalSum && parseInt(loadingResults.totalSum) > 0)">
            <div class="alert alert-danger mb-3 mr-4" role="alert" v-if="loadingResults.replacePayments && loadingResults.replacePayments.length > 0">
              <p class="danger">{{$t('notifications.replacePaymentsFound')}}: {{loadingResults.replacePayments.length}}</p>
            </div>
          </div>
        </b-card-body>
      </b-card>
    </div>
    <div class="col-lg-8 col-xs-12">
        <b-card>
          <h6 class="card-title mt-0 mb-2">{{$t('views.exsbbankpackages.index.showAll')}}</h6>
          <b-card-body>
            <Loader v-if="loading"></Loader>
            <table v-else class="table table-sm table-striped table-hover">
              <thead>
              <tr>
                <th>{{$t('views.agreements.list.created')}}</th>
                <th>{{$t('views.excmconsent.show.description')}}</th>
                <th>{{$t('views.exsbbankpackages.show.value')}}</th>
                <th>{{$t('views.exsbbankpackages.show.count')}}</th>
                <th>{{$t('views.exsbbankpackages.show.unlinkCount')}}</th>
                <th>{{$t('views.exsbbankpackages.show.bankTitle')}}</th>
                <th>{{$t('views.excmtag.options')}}</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="item in rowsdata" :key="item.id">
                <td>{{ item.createdAt }}</td>
                <td>{{ item.description }}</td>
                <td>{{ item.value }}</td>
                <td>
                  <router-link :to="{name: 'EXSBBankPackagesShow', params: { id: item['@id'] }}">
                    <div>{{ item.count }}</div>
                  </router-link>
                </td>
                <td>{{ item.unlinkCount }}</td>
                <td>{{ item.bank }}</td>
                <td>
                  <b-dropdown
                    class="float-left"
                    size="sm" variant="link"
                    right text="Right align"
                    toggle-class="text-decoration-none" no-caret>
                    <template #button-content>
                      <i class="fa fa-bars fa-lg"></i>
                    </template>
                    <b-dropdown-item @click="$router.push({name: 'EXSBBankPackagesShow', params: { id: item['@id'] }})"><i class="fa fa-eye mr-2"></i>{{$t('buttons.preview')}}</b-dropdown-item>
                    <b-dropdown-item @click="deleteSingle(item['@id'])"><i class="fa fa-trash"></i> {{$t('buttons.delete')}}</b-dropdown-item>
                  </b-dropdown>
                </td>
              </tr>
              </tbody>
            </table>
            <div v-if="view">
              <pagination :view="view" :totalItems="totalItems" @getPage="fetchData($event)"></pagination>
            </div>
          </b-card-body>
        </b-card>
    </div>
  </div>
</template>

<script>
import VueForm from 'vue-form'
import Loader from '@/components/Dashboard/Layout/Loader'
import Pagination from '@/components/Dashboard/Layout/Pagination'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import remove from '@/utils/remove'

export default {
  name: 'BankPackagesList',
  mixins: [VueForm],
  components: {
    Loader,
    Pagination
  },
  data () {
    return {
      loading: true,
      display: true,
      data: {
        idBank: undefined,
        description: '',
        bankFile: null
      },
      formstate: {},
      loadingResults: {},
      downloadXlsStatus: 0,
      banksOptions: [],
      rowsdata: [],
      totalItems: 0,
      view: null
    }
  },
  created () {
    this.fetchData()
    this.fetchBankList()
  },
  methods: {
    async getId (iri) {
      return getId(iri)
    },
    store () {
      this.display = false
      let data = new FormData()
      data.append('idBank', this.data.idBank)
      data.append('description', this.data.description)
      data.append('bankFile', this.data.bankFile)
      this.$http.post('api/e_x_s_b_upload_bank_package', data, {
        headers: {
          'Content-Type': 'multipart/form-data; charset=utf-8; boundary="' + Math.random().toString().substr(2) + '"'
        }
      })
        .then(response => {
          if (response.status === 200) { // 201 code - Object created. Useful for the store actions.
            this.$Swal({
              type: 'success',
              title: this.$t('views.exsbbankpackages.form.dataHasBeenProcessedAndGetIt'),
              timer: 2500
            })
            this.loadingResults = response.data
            this.clearData()
            this.fetchData() // fetchdata to table
            this.display = true
          } else {
            let text = ''
            for (let i in response.data) {
              text += response.data[i] + '\n'
            }
            this.$Swal({
              type: 'warning',
              title: text,
              showConfirmButton: true
            })
            this.fetchData() // fetchdata to table
            this.display = true
          }
        })
        .catch(error => {
          this.$Swal({
            type: 'warning',
            title: this.$t('notifications.store.errorTitle') + ' - ' + error,
            showConfirmButton: false,
            timer: 2500
          })
          this.display = true
        })
    },
    onSubmit () {
      if (this.formstate.$invalid) {
        return
      }
      this.store()
    },
    async fetchBankList () {
      let params = { pagination: false }
      const response = await new ApiService('e_x_s_b_banks', params).getResults()
      this.banksOptions = response.items.map(entry => { return { value: entry['@id'], text: entry.title } })
      this.banksOptions.unshift({ text: this.$t('global.notSet'), value: null })
    },
    async fetchData (url = 'e_x_s_b_bank_packages') {
      this.loading = true
      const response = await new ApiService(url).getResults()
      this.rowsdata = response.items
      for (let i in this.rowsdata) {
        this.rowsdata[i].bank = this.rowsdata[i].idBank.title
        this.rowsdata[i].createdAt = this.$moment(this.rowsdata[i].createdAt).format('YYYY-MM-DD')
        this.rowsdata[i].value = parseFloat(this.rowsdata[i].value).toFixed(2)
      }
      this.view = response.view
      this.totalItems = response.totalItems
      this.loading = false
    },
    clearData () {
      this.data.data = {
        idBank: undefined,
        description: '',
        bankFile: null
      }
    },
    cancelButton () {
      this.clearData()
      this.$Swal({
        type: 'success',
        title: this.$t('views.exsbbankpackages.form.dataClear'),
        showConfirmButton: false,
        timer: 2500
      })
    },
    deleteSingle (id) {
      remove(id, () => {
        this.fetchData()
      })
    }
  }
}
</script>

<style scoped>

</style>
